import React, { useState, Fragment, useEffect } from "react";

import JobDetailView from "../../../components/jobs/JobDetailView";
import { NextSeo, JobPostingJsonLd } from "next-seo";
import { Message, Section, Columns } from "react-bulma-components";
import { displayCurrency, getPublicStorageUrl } from "../../../utils";
import { FRONTEND } from "../../../constants";
import { db } from "../../../lib/firebase";

const JobDetailsPage = ({ job, logoUrl }) => {
  if (job) {
    return (
      <Fragment>
        <NextSeo
          title={`${job.headline} | Bounty: ${displayCurrency(
            job.bounty,
            job.bountyCurrency
          )} | ${job.company.name}`}
          description={`${job.description}`}
          openGraph={{
            type: "website",
            url: `${FRONTEND}/jobs/${job.id}`,
            title: `${job.headline} | Bounty: ${displayCurrency(
              job.bounty,
              job.bountyCurrency
            )} | ${job.company.name}`,
            description: `${job.description}`,
            images: [
              {
                url: `${FRONTEND}/og-image/${
                  job.bounty > 0
                    ? displayCurrency(job.bounty, job.bountyCurrency)
                    : "Apply"
                }.png?image=${encodeURIComponent(logoUrl)}`,
                alt: `${job.headline} | Bounty: ${displayCurrency(
                  job.bounty,
                  job.bountyCurrency
                )} | ${job.company.name}`
              }
            ]
          }}
        />
        <JobPostingJsonLd
          datePosted={`${job.modified}`}
          description={job.description}
          hiringOrganization={{
            sameAs: job.company.webUrl || "",
            name: job.company.name
          }}
          jobLocation={{
            addressLocality: job.location?.city,
            addressCountry: job.location?.country,
            streetAddress: job.location?.streetAddress,
            postalCode: job.location?.postalCode
          }}
          title={job.headline}
          baseSalary={{
            currency: job.salaryCurrency,
            value: job.minSalary,
            unitText: job.payUnit
          }}
          employmentType={job.employmentType}
          jobLocationType={job.isRemote ? "TELECOMMUTE" : ""}
          validThrough={`${job.expiry}`}
          applicantLocationRequirements={job.applicantCountry}
        />
        <JobDetailView job={job} />
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <NextSeo
          title={`Job not found`}
          description={`We couldn't find the job you requested in our database.`}
        />
        <Section>
          <Columns>
            <Columns.Column size={4} offset={4}>
              <Message>
                <Message.Header>Not Found.</Message.Header>
                <Message.Body>
                  We couldn't find that job in our database.
                </Message.Body>
              </Message>
            </Columns.Column>
          </Columns>
        </Section>
      </Fragment>
    );
  }
};

export const getServerSideProps = async context => {
  const docRef = await db.doc(`jobs/${context.query.id}`).get();
  if (docRef.exists) {
    const docData = docRef.data();
    const job = {
      id: context.query.id,
      ...docData,
      expiry: docData.expiry.toDate().toISOString(),
      created: docData?.created?.toDate().toISOString(),
      updated: docData?.updated?.toDate().toISOString()
    };
    let logoUrl = null;
    if (job?.company?.logo) {
      logoUrl = getPublicStorageUrl(job.company.logo);
    }
    return {
      props: {
        job,
        logoUrl
      }
    };
  } else {
    return {
      props: {}
    };
  }
};

export default JobDetailsPage;
